<template>
  <nav>
    <router-link to="/">Home</router-link> |
    <!-- <router-link to="/carnivore">Carnivore Guidelines</router-link>
    <br/> -->
    <router-link to="/fatcalc">Body Fat Calculator</router-link> |
    <router-link to="/contact">Contact Me</router-link>
    <!--<router-link to="/about">About</router-link>-->
  </nav>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #b1bfce;
  background-color: #20202F;
  min-height: 100vh;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #b1bfce;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
